import { NotificationService } from 'app/shared/utils/notification.service';
import * as moment from 'moment';

import { IMyDpOptions } from './shared/custom/mydatepicker/dist';
import { IMultiSelectOption } from "app/shared/custom/angular-2-dropdown-multiselect/src/multiselect-dropdown";

export abstract class BaseComponent {
  public mask = [/[0-9]/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
  public model: any = { date: { year: 2018, month: 10, day: 9 } };

  public myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'dd/mm/yyyy',
    todayBtnTxt: 'Hoje',
    dayLabels: { su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sat' },
    monthLabels: {
      1: 'Jan', 2: 'Fev', 3: 'Mar', 4: 'Abr', 5: 'Maio', 6: 'Jun', 7: 'Jul',
      8: 'Ago', 9: 'Set', 10: 'Out', 11: 'Nov', 12: 'Dez'
    }
  };

  constructor(public notificationService: NotificationService) { }

  onDateChanged(event: IMyDpOptions) {

  }

  onSubmit(): void {

  }

  onClearDate(): void {
    this.model = '';
  }

  // Genério para enums de dominio
  preencherValoresEnum(tipoEnum) {
    const objetos = [];

    const valoresEnum = Object.keys(tipoEnum);

    valoresEnum.forEach(x => {
      objetos.push(tipoEnum[x]);
    });

    return objetos;
  }

  formatarDataExibicaoString(dataDocumento: string) {
    if (dataDocumento) {
      let dia: string = null;
      let mes: string = null;
      let ano: string = null;

      if (dataDocumento.search('T') > 0) {
        const data = dataDocumento.split('T')[0];
        dia = data.split('-')[2];
        mes = data.split('-')[1];
        ano = data.split('-')[0];
      } else {
        const data = dataDocumento.split(' ')[0];
        dia = data.split('/')[0];
        mes = data.split('/')[1];
        ano = data.split('/')[2];
      }
      dataDocumento = dia + '/' + mes + '/' + ano;
    }

    return dataDocumento;
  }

  getDateFromString(dataString: string) {
    let dia: string = null;
    let mes: string = null;
    let ano: string = null;
    if (dataString) {
      dia = dataString.split('/')[0];
      mes = dataString.split('/')[1];
      ano = dataString.split('/')[2];
      return new Date(Number.parseInt(ano), Number.parseInt(mes) - 1, Number.parseInt(dia));
    }
    return dataString;
  }

  formatarDataExibicaoCalendario(dataDocumento: string) {
    if (dataDocumento) {
      const dataDocumentoFormatadaCalendario = {
        date: {
          year: new Date(dataDocumento).getFullYear(),
          month: new Date(dataDocumento).getMonth() + 1,
          day: new Date(dataDocumento).getDate(),
        }
      }
      return dataDocumentoFormatadaCalendario;
    }

    return dataDocumento;
  }

  montarDataFormatada(data: any) {
    data = new Date(data.date.year, data.date.month - 1, data.date.day);
    return data;
  }

  montarDataFormatadaJson(data) {
    if (data) {
      return {
        date: {
          year: new Date(moment(data).format('YYYY/MM/DD')).getFullYear(),
          month: new Date(moment(data).format('YYYY/MM/DD')).getMonth() + 1,
          day: new Date(moment(data).format('YYYY/MM/DD')).getDate(),
        },
        jsdate: new Date(moment(data).format('YYYY/MM/DD')),
        formatted: moment(data).format('DD/MM/YYYY')
      }
    }

    return data;
  }

  arredondarEFormatarValores(numero: number) {
    const valorFinal = '0,00';
    if (numero) {
      const numeros = numero.toFixed(2).split('.');
      numeros[0] = numeros[0].split(/(?=(?:...)*$)/).join('.');
      return numeros.join(',');
    }
    return valorFinal;
  }

  arredondarEFormatarValoresComMascara(numero: number) {
    return 'R$ ' + this.arredondarEFormatarValores(numero);
  }

  formatarValoresString(numeroString: string) {
    return this.arredondarEFormatarValores(parseFloat(numeroString));
  }

  formatarValoresStringComMascara(numeroString: string) {
    return this.arredondarEFormatarValoresComMascara(parseFloat(numeroString));
  }

  public temPermissao(tipoClaim: string, acao: string) {
    const claims = JSON.parse(localStorage.getItem('dn-senac-seguranca'))["claims"];
    const resultado = claims.some(x => x.tipo === tipoClaim && x.acoes.some(y => y.nomeAcao === acao));
    return resultado;
  }

  //Genérico para preencher multiselects
  criarOpcoesMultiselect(lista: any[]) {

    let opcoes: IMultiSelectOption[] = [];

    lista.forEach(x => {
      opcoes.push({
        id: x.id,
        nome: x.descricao
      })
    });

    return opcoes;
  }

  exibirNotificacaoErro(titulo: string, mensagem: string) {
    this.notificationService.bigBox({
      title: titulo,
      content: mensagem,
      color: "#c13636",
      icon: "fa fa-ban swing animated",
      number: "4",
      timeout: 6000
    });
  }

  exibirNotificacaoAlerta(titulo: string, mensagem: string) {
    this.notificationService.bigBox({
      title: titulo,
      content: mensagem,
      color: "#ff7f00",
      icon: "fa fa-exclamation-triangle swing animated",
      number: "4",
      timeout: 6000
    });
  }

  exibirNotificacaoSucesso(titulo: string, mensagem: string) {
    this.notificationService.bigBox({
      title: titulo,
      content: mensagem,
      color: "#739E73",
      icon: "fa fa-check swing animated",
      number: "4",
      timeout: 6000
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/base.component.ts